import type {GetLottieAnimationFn} from '../../../uikit/LottieView/types';

import {lottieColorify} from '../../../uikit/LottieView/colorify';
import animationJson from './animation.json';

const colorifyLayers = ['check', 'cal header'];

export const getCalendarCheckAnimation: GetLottieAnimationFn = (
  color: string,
) => {
  return lottieColorify({
    color,
    layers: colorifyLayers,
    source: animationJson,
  });
};
